import { Theme } from "@material-ui/core";
const styles = (theme: Theme) =>
  ({
    containerConfirmation: {
      padding: 24,
      textAlign: "center",
      "& h4": {
        fontWeight: "400",
      },
      "& h3": {
        fontWeight: "400",
        padding: "24px 0",
      },
    },
    container: {
      padding: "24px 0",
    },
    logo: {
      width: 120,
    },
    illu: {
      width: 550,
    },
    title: {
      textAlign: "center",
      "& > h2": {
        fontWeight: "300",
      },
    },

    "@media all and (max-width: 430px)": {},
  } as any);

export default styles;
